import React from 'react';
import { ColumnsType } from 'antd/es/table';
import DetalleMetrica from './DetalleMetrica';

const DetalleOtrasSalidas: React.FC = () => {
  const columns: ColumnsType<any> = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
    { title: 'Nro. Orden', dataIndex: 'nro_orden', key: 'nro_orden', width: 120, align: 'right' as const },
    { title: 'Fecha Orden', dataIndex: 'fecha_orden', key: 'fecha_orden', width: 120 },
    { title: 'Tipo Orden', dataIndex: 'tipo_orden', key: 'tipo_orden', width: 120 },
    { title: 'Nro. Fardo', dataIndex: 'nro_fardo', key: 'nro_fardo', width: 120, align: 'right' as const },
    { title: 'Nro. Lote', dataIndex: 'nro_lote', key: 'nro_lote', width: 120, align: 'right' as const },
    { title: 'Motivo', dataIndex: 'motivo', key: 'motivo', width: 120 },
    { title: 'Descripción Motivo', dataIndex: 'descripcion_motivo', key: 'descripcion_motivo', width: 250 },
  ];

  const fetchData = async (idEmpresa: number, idProducto: number, token: string): Promise<any[]> => {
    const url = `${process.env.REACT_APP_ESTADISTICAS_URL}/detalle/otras-salidas/${idEmpresa}/${idProducto}/`;
    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    if (!response.ok) throw new Error(`Error al cargar datos: ${response.status}`);
    return await response.json();
  };

  return (
    <DetalleMetrica
      titulo="Detalle de Otras Salidas"
      descripcion="Despachos que no son ventas (bajas, transferencias, etc.)"
      fetchData={fetchData}
      columns={columns}
      nombreArchivo="otras_salidas"
    />
  );
};

export default DetalleOtrasSalidas;

